import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, FormControlLabel, Switch } from '@mui/material';
import { useAgencyInfo } from "context/agency";
import { useAccountById, useUpdateAccountPlugin } from "queries/accounts";
import { useLocation } from 'react-router-dom';
import SoftButton from 'components/SoftButton';
import { FaRegStar } from "react-icons/fa6";

const PluginManager = () => {
    const [agency] = useAgencyInfo();
    const [activePlugins, setActivePlugins] = useState([]);
    const [loading, setLoading] = useState({});
    const [agentLimit, setAgentLimit] = useState(0); // Ensure it's a number
    const [originalPlugins, setOriginalPlugins] = useState([]);
    const [toggleChecked, setToggleChecked] = useState(false);
    const location = useLocation();
    const lastParam = location.pathname.split('/').pop();

    // Same "accounts" resource/id this account's other tabs (AccountDetail,
    // PromptLabels) fetch - shares the cache entry instead of refetching.
    const { data: accountData, isLoading: isAccountLoading } = useAccountById(lastParam);

    const activeAccount = accountData?.data;
    const agentConfig = activeAccount?.agenct_config;

    useEffect(() => {
        if (agentConfig) {
            const { plugins, allow, agent_limit } = agentConfig;
            setToggleChecked(allow);
            setAgentLimit(agent_limit ?? 0);
            setActivePlugins(plugins || []);
            setOriginalPlugins(plugins ? plugins.map(p => ({ ...p })) : []);
        }
    }, [agentConfig]);

    const { mutateAsync: updatePlugin } = useUpdateAccountPlugin();

    const handleToggleChange = async () => {
        setToggleChecked((prev) => !prev);
        const payload = { id: lastParam, agentconfig: !toggleChecked };
        await updatePlugin(payload);
    };

    const formatString = (str) => str.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').trim();

    const handlePluginsChange = (agencyId, plugin) => {
        setActivePlugins((prev) => {
            const updatedPlugins = prev.map((p) =>
                p.id === plugin.id
                    ? { ...p, is_active_for_account: !p.is_active_for_account }
                    : p
            );
            return updatedPlugins;
        });
    };

    const handleSubmit = async (accountId) => {
        setLoading((prev) => ({ ...prev, [accountId]: true }));

        // Find only changed plugins
        const changedPlugins = activePlugins?.filter(plugin => {
            const original = originalPlugins.find(p => p.id === plugin.id);
            return original && plugin.is_active_for_account !== original.is_active_for_account;
        }).map(plugin => ({
            id: plugin.id,
            is_active_for_account: plugin.is_active_for_account
        }));

        if (changedPlugins.length === 0) {
            setLoading((prev) => ({ ...prev, [accountId]: false }));
            return;
        }

        const payload = {
            id: accountId,
            plugins: changedPlugins
        };

        try {
            await updatePlugin(payload);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading((prev) => ({ ...prev, [accountId]: false }));
        }
    };

    console.log('activePlugins', activePlugins);

    if (isAccountLoading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
                <CircularProgress size={28} />
            </div>
        );
    }

    return (
        <div>
            <>
                <div>
                    {activePlugins?.filter((plugin) => plugin?.is_active_for_account)?.map((plugin) => (
                        <div key={plugin?.id} style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', width: '100%', padding: '10px' }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                {formatString(plugin?.name).toUpperCase()}
                            </h3>

                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={plugin?.is_active_for_account}
                                            onChange={() => handlePluginsChange(agency?.location_id, plugin)}
                                            color="primary"
                                        />
                                    }
                                />
                        </div>
                    ))}
                </div>

                <div style={{ textAlign: "right", marginTop: '20px' }}>
                    <SoftButton
                        color="dark"
                        onClick={() => handleSubmit(activeAccount?._id)}
                        disabled={loading[activeAccount?._id]}
                    >
                        {loading[activeAccount?._id] ? "Loading..." : "Submit"}
                    </SoftButton>
                </div>
            </>
        </div>
    );
};

export default PluginManager;
